'use client';

import { useQuery } from '@tanstack/react-query';

import { Services } from '@/infra/services';

const useGetProductsMetadata = (page: number) => {
  const result = useQuery({
    queryKey: ['get-products-metadata', page],
    queryFn: () => Services.SiteMap.getProductsMetadata({ page }),
  });

  return result;
};

export default useGetProductsMetadata;
